import type { Nullable } from '../types/interfaces';

/**
 * Totales de monto otorgado que puede devolver el listado de solicitudes (comité).
 * Se aceptan variantes snake_case / camelCase hasta confirmar contrato final con backend.
 *
 * Soft-rename (Option A): `*_ars` / `*Ars` fields are the **tenant local currency bucket**
 * (ARS or UYU), not Argentina-only. Wire/DB names stay unchanged.
 */
export function parseGrantedTotalsFromApplicationListItem(item: unknown): {
  granted_total_ars: Nullable<number>;
  granted_total_usd: Nullable<number>;
} {
  if (item == null || typeof item !== 'object') {
    return { granted_total_ars: null, granted_total_usd: null };
  }
  const o = item as Record<string, unknown>;
  const arsRaw =
    o.granted_total_ars ??
    o.grantedTotalArs ??
    o.granted_total_amount_ars ??
    o.grantedTotalAmountArs;
  const usdRaw =
    o.granted_total_usd ??
    o.grantedTotalUsd ??
    o.granted_total_amount_usd ??
    o.grantedTotalAmountUsd;

  return {
    granted_total_ars: toNullableNumber(arsRaw),
    granted_total_usd: toNullableNumber(usdRaw),
  };
}

function toNullableNumber(v: unknown): Nullable<number> {
  if (v === null || v === undefined || v === '') return null;
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : null;
}
